export const UserAuthorityChoice = {
  ADMIN: "1",
  BUSINESS: "2",
  GENERAL: "3",
};

export const getUserAuthorityName = (value) => {
  let name = "";
  //1베이스여서 -1 처리
  const key = Object.keys(UserAuthorityChoice)[value - 1];
  switch (key) {
    case "ADMIN":
      name = "시스템관리자";
      break;
    case "BUSINESS":
      name = "사업자";
      break;
    case "GENERAL":
      name = "사용자";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const GeneralUserTypeChoice = {
  FIRE_SAFETY_ADMIN: "0",
  ASSISTANT_SAFETY_ADMIN: "1",
  BUILDING_OWNER: "2",
};

export const getGeneralUserTypeName = (value) => {
  let name = "";
  const key = Object.keys(GeneralUserTypeChoice)[value];
  switch (key) {
    case "FIRE_SAFETY_ADMIN":
      name = "소방안전관리자";
      break;
    case "ASSISTANT_SAFETY_ADMIN":
      name = "보조안전관리자";
      break;
    case "BUILDING_OWNER":
      name = "건물 관계인";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

//community
export const SystemBoardSearchType = {
  TITLE: "1",
  CONTENT: "2",
  TITLE_CONTENT: "3",
};

export const getSystemBoardSearchTypeName = (value) => {
  let name = "";
  //1베이스여서 -1 처리
  const key = Object.keys(SystemBoardSearchType)[value - 1];
  switch (key) {
    case "TITLE":
      name = "제목";
      break;
    case "CONTENT":
      name = "내용";
      break;
    case "TITLE_CONTENT":
      name = "제목+내용";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const NoticeBoardSearchType = {
  TITLE: "1",
  AUTHOR: "2",
  TITLE_AUTHOR: "3",
};

export const getNoticeBoardSearchTypeName = (value) => {
  let name = "";
  //1베이스여서 -1 처리
  const key = Object.keys(NoticeBoardSearchType)[value - 1];
  switch (key) {
    case "TITLE":
      name = "제목";
      break;
    case "AUTHOR":
      name = "작성자";
      break;
    case "TITLE_AUTHOR":
      name = "제목+작성자";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const FireReceiverStatus = {
  ALL: "0",
  NORMAL: "1",
  SUSPENDED: "2",
  TERMINATED: "3",
  DISCARDED: "4",
};

export const getFireReceiverStatusName = (value) => {
  let name = "";
  const key = Object.keys(FireReceiverStatus)[value];
  switch (key) {
    case "ALL":
      name = "전체";
      break;
    case "NORMAL":
      name = "정상";
      break;
    case "SUSPENDED":
      name = "일시정지";
      break;
    case "TERMINATED":
      name = "해지";
      break;
    case "DISCARDED":
      name = "폐기";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const FireReceiverSearchType = {
  SERIAL_NUMBER: "0",
  DEI: "1",
  MODEL_CODE: "2",
  BUILDING_NAME: "3",
};

export const getFireReceiverSearchTypeName = (value) => {
  let name = "";
  const key = Object.keys(FireReceiverSearchType)[value];
  switch (key) {
    case "SERIAL_NUMBER":
      name = "화재수신기 일련번호";
      break;
    case "DEI":
      name = "화재수신기 DEI";
      break;
    case "MODEL_CODE":
      name = "화재수신기 모델코드";
      break;
    case "BUILDING_NAME":
      name = "소방대상물";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const FireReceiverStatusChoice = {
  ACTIVE: "0",
  INACTIVE: "1",
  SUSPENDED: "2",
};

export const getFireReceiverStatusChoiceName = (value) => {
  let name = "";
  const key = Object.keys(FireReceiverStatusChoice)[value];
  switch (key) {
    case "ACTIVE":
      name = "활성";
      break;
    case "INACTIVE":
      name = "비활성";
      break;
    case "SUSPENDED":
      name = "일시정지";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const UserStatusChoice = {
  ALL: "0",
  NORMAL: "1",
  SUSPENDED: "2",
  TERMINATED: "3",
};

export const getUserStatusName = (value) => {
  let name = "";
  const key = Object.keys(UserStatusChoice)[value];
  switch (key) {
    case "ALL":
      name = "전체";
      break;
    case "NORMAL":
      name = "정상";
      break;
    case "SUSPENDED":
      name = "일시정지";
      break;
    case "TERMINATED":
      name = "해지";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const BusinessUserSearchType = {
  COMPANY_NAME: "0",
  BUSINESS_NUMBER: "1",
  MANAGER_NAME: "2",
  LOGIN_ID: "3",
};

export const getBusinessUserSearchTypeName = (value) => {
  let name = "";
  const key = Object.keys(BusinessUserSearchType)[value];
  switch (key) {
    case "COMPANY_NAME":
      name = "업체명";
      break;
    case "BUSINESS_NUMBER":
      name = "사업자번호";
      break;
    case "MANAGER_NAME":
      name = "담당자";
      break;
    case "LOGIN_ID":
      name = "로그인ID";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const GeneralUserSearchType = {
  NAME: "0",
  LOGIN_ID: "1",
};

export const getGeneralUserSearchTypeName = (value) => {
  let name = "";
  const key = Object.keys(GeneralUserSearchType)[value];
  switch (key) {
    case "NAME":
      name = "이름";
      break;
    case "LOGIN_ID":
      name = "로그인ID";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const FacilityCategoryChoice = {
  FIRE_INPUT: "1",
  FIRE_OUTPUT: "2",
  FIRE_SUPPRESSION: "3",
  SMOKE_CONTROL: "4",
  EVACUATION: "5",
};

export const getFacilityCategoryName = (value) => {
  let name = "";
  //1베이스여서 -1 처리
  const key = Object.keys(FacilityCategoryChoice)[value - 1];
  switch (key) {
    case "FIRE_INPUT":
      name = "화재입력설비";
      break;
    case "FIRE_OUTPUT":
      name = "화재출력설비";
      break;
    case "FIRE_SUPPRESSION":
      name = "소화설비";
      break;
    case "SMOKE_CONTROL":
      name = "제연설비";
      break;
    case "EVACUATION":
      name = "피난설비";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const FireReceiverMdbFilterType = {
  ALL: "1",
  MODEL_NAME: "2",
  APPROVAL_NUMBER: "3",
  SERIAL_NUMBER: "4",
  DEI_NUMBER: "5",
  MANUFACTURE_DATE: "6",
  MANUFACTURER: "7",
  LOT_NUMBER: "8",
  INSPECTION_PASS_NUMBER: "9",
  REGISTRANT: "10",
  REGISTERED_AT: "11",
};

export const getFireReceiverMdbFilterTypeName = (value) => {
  let name = "";
  //1베이스여서 -1 처리
  const key = Object.keys(FireReceiverMdbFilterType)[value - 1];
  switch (key) {
    case "ALL":
      name = "전체";
      break;
    case "MODEL_NAME":
      name = "모델명";
      break;
    case "APPROVAL_NUMBER":
      name = "형식승인번호";
      break;
    case "SERIAL_NUMBER":
      name = "제조일련번호";
      break;
    case "DEI_NUMBER":
      name = "통신DEI번호";
      break;
    case "MANUFACTURE_DATE":
      name = "제조일자";
      break;
    case "MANUFACTURER":
      name = "제조업체";
      break;
    case "LOT_NUMBER":
      name = "로트번호";
      break;
    case "INSPECTION_PASS_NUMBER":
      name = "검사합격번호";
      break;
    case "REGISTRANT":
      name = "등록자";
      break;
    case "REGISTERED_AT":
      name = "등록일";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const FirefightingObjectFilterType = {
  ALL: "1",
  BUILDING_NAME: "2",
  SERIAL_NUMBER: "3",
};

export const getFirefightingObjectFilterTypeName = (value) => {
  let name = "";
  //1베이스여서 -1 처리
  const key = Object.keys(FirefightingObjectFilterType)[value - 1];
  switch (key) {
    case "ALL":
      name = "전체";
      break;
    case "BUILDING_NAME":
      name = "대상물 명";
      break;
    case "SERIAL_NUMBER":
      name = "화재수신기 일련번호";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const StatusChoices = {
  NORMAL: "1",
  COMM_ERROR: "2",
  FIRE_DETECTED: "3",
  INSPECTION: "4",
};

export const getStatusName = (value) => {
  let name = "";
  //1베이스여서 -1 처리
  const key = Object.keys(StatusChoices)[value - 1];
  switch (key) {
    case "NORMAL":
      name = "정상";
      break;
    case "COMM_ERROR":
      name = "통신장애";
      break;
    case "FIRE_DETECTED":
      name = "화재감지";
      break;
    case "INSPECTION":
      name = "소방점검";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const getStatusColorClassName = (value) => {
  let className = "";
  //1베이스여서 -1 처리
  const key = Object.keys(StatusChoices)[value - 1];
  switch (key) {
    case "NORMAL":
      className = "greenMark";
      break;
    case "COMM_ERROR":
      className = "yellowMark";
      break;
    case "FIRE_DETECTED":
      className = "redMark";
      break;
    case "INSPECTION":
      className = "greyMark";
      break;
    default:
      className = "";
      break;
  }

  return className;
};

export const getStatusClassName = (value) => {
  let className = "";
  //1베이스여서 -1 처리
  const key = Object.keys(StatusChoices)[value - 1];
  switch (key) {
    case "NORMAL":
      className = "status-normal";
      break;
    case "COMM_ERROR":
      className = "status-comm-error";
      break;
    case "FIRE_DETECTED":
      className = "status-fire-detected";
      break;
    case "INSPECTION":
      className = "status-maintenance";
      break;
    default:
      className = "";
      break;
  }

  return className;
};

export const FirefightingActionEnum = {
  ACCUMULATION: "1",
  GUIDING_LIGHT: "2",
  INDICATOR_LIGHT: "3",
  FIRE_ALARM: "4",
  OPERATION_TEST: "5",
  CIRCUIT_BUZZER: "6",
  MAIN_ALARM: "7",
  LOCAL_ALARM: "8",
  AUTO_RECOVERY: "9",
  FIRE_RECOVERY: "10",
};

export const getFirefightingActionEnumName = (value) => {
  let name = "";
  //1베이스여서 -1 처리
  const key = Object.keys(FirefightingActionEnum)[value - 1];
  switch (key) {
    case "ACCUMULATION":
      name = "축적";
      break;
    case "GUIDING_LIGHT":
      name = "유도등";
      break;
    case "INDICATOR_LIGHT":
      name = "비상방송";
      break;
    case "FIRE_ALARM":
      name = "화재이보";
      break;
    case "OPERATION_TEST":
      name = "동작시험";
      break;
    case "CIRCUIT_BUZZER":
      name = "부저 정지";
      break;
    case "MAIN_ALARM":
      name = "주경종 정지";
      break;
    case "LOCAL_ALARM":
      name = "지구경종 정지";
      break;
    case "AUTO_RECOVERY":
      name = "자동복구";
      break;
    case "FIRE_RECOVERY":
      name = "화재복구";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const FireAlarmHistoryResultChoices = {
  REAL: "1",
  FALSE: "2",
};

export const getFireAlarmHistoryResultName = (value) => {
  let name = "";
  //1베이스여서 -1 처리
  const key = Object.keys(FireAlarmHistoryResultChoices)[value - 1];
  switch (key) {
    case "REAL":
      name = "실화재";
      break;
    case "FALSE":
      name = "비화재";
      break;
    default:
      name = "";
      break;
  }

  return name;
};

export const convertToRoundValue = (value) => {
  if (value !== null) {
    return parseFloat(value.toFixed(1));
  } else {
    return 0;
  }
};

export const checkDecimalPoint = (value) => {
  const regexp = /^\d*.?\d{0,1}$/;
  if (!regexp.test(value)) {
    alert(`소수점 첫째자리까지 입력가능합니다.`);
    return false;
  } else {
    return true;
  }
};
